import { googleMapsUrl } from './maps';

/**
 * Public "Take me home" directions.
 *
 * Destination only — no origin — so Maps starts from the phone's location.
 * Postal address, no unit number. "Alfanzina" and the urbanização line are
 * not the postal town the geocoder should be given.
 */
export const TAKE_ME_HOME_ADDRESS = 'Rocha Brava, 8400-568 Carvoeiro, Portugal';

export function takeMeHomeDirectionsUrl(): string {
  return googleMapsUrl(TAKE_ME_HOME_ADDRESS);
}
